import React from 'react';
import PostPreview from 'gatsby-theme-dcdw-wp-blog/src/components/post-preview';

const PDVShadowLatestBlogPreview = (props) => (
  <PostPreview lang="nl" threeColumn {...props} />
);

export default PDVShadowLatestBlogPreview;
